import styled from "styled-components";

export const LastUpdatedWrapper = styled.div`
  display: flex;
  gap: 4px;
`;

export const LastUpdateMainWrapper = styled.div<{
  placeRight?: boolean;
}>`
  display: flex;
  justify-content: ${(props) => (props?.placeRight ? "flex-end" : "")};
`;
